import styles from './PageBackButton.module.css'
import ArrowBack from '../../Icons/arrow-final-left-grey.png'

type Props = {
    onClick:any
};

const PageBackButton = (props: Props) => {
    const {onClick} = props;
  return (
    <>
      <div onClick={onClick} className={styles.backButtonDiv}>
        <div className={styles.backButtonContent}>
          <img className={styles.backButtonImage} src={ArrowBack} />
          <h5 className={styles.backButtonText}>Back</h5>
        </div>
      </div>
    </>
  );
};

export default PageBackButton;
